import { CATEGORY } from "../actions";

const initialState = {
  categoryName: "",
  rowsPerPage: 12,
  currentPage: 1,
  categoryFetching: false,
  categoryData: null,
  totalItems: 0,
  categoryError: false,
  categoryDataError: null
};

export default (state = initialState, { type, payload, error }) => {
  switch (type) {
    case CATEGORY.CATEGORY_CHANGE:
      return { ...state, categoryName: payload, currentPage: 1 };

    case CATEGORY.CURRENT_PAGE_CHANGE: {
      return { ...state, currentPage: payload };
    }

    case CATEGORY.CATEGORY_ITEM_PENDING:
      return { ...state, categoryFetching: true };

    case CATEGORY.CATEGORY_ITEM_SUCCESS:
      return {
        ...state,
        categoryFetching: false,
        categoryData: payload,
        totalItems: payload.length
      };

    case CATEGORY.CATEGORY_ITEM_FAILED:
      return {
        ...state,
        categoryFetching: false,
        categoryError: true,
        categoryDataError: error,
        categoryData: [],
        totalItems: 0
      };

    default:
      return state;
  }
};
